import { assign, forEach } from '~/utils';

/**
 * 默认图表配置
 */
const getDefaultChartOptions = () => {
    return {
        padding: 5,
        zoom: {
            zoomType: 'xy'
        },
        plotOptions: {
            large: false,
            connectNulls: true,
            curve: false,
            marker: {
                symbol: 'circle',
                radius: 4.5,
                enabled: true
            },
            tooltip: {
                formatter: {
                    // eslint-disable-next-line no-template-curly-in-string
                    identifier: '${CATEGORY}${SERIES}${VALUE}'
                },
                shared: true,
                padding: 5,
                backgroundColor: 'rgba(0,0,0,0.4980392156862745)',
                borderColor: 'rgb(0,0,0)',
                shadow: false,
                borderRadius: 2,
                borderWidth: 0,
                follow: false,
                enabled: true,
                animation: true,
                hideDelay: 3000
            },
            step: false,
            lineWidth: 2,
            animation: true
        },
        drag: true,
        borderColor: 'rgb(238,238,238)',
        xAxis: {
            enableMinorTick: false,
            minorTickColor: 'rgb(176,176,176)',
            tickColor: 'rgb(176,176,176)',
            showArrow: false,
            lineColor: 'rgb(176,176,176)',
            plotLines: [],
            type: 'category',
            lineWidth: 1,
            showLabel: true,
            gridLineWidth: 0,
            enableTick: true,
            labelStyle: {
                fontFamily: 'verdana',
                color: '#6f6f6f',
                fontSize: '10px'
            },
            plotBands: [],
            position: 'bottom',
            labelRotation: 0,
            reversed: false
        },
        legend: {
            borderColor: 'rgb(204,204,204)',
            borderRadius: 0,
            shadow: false,
            borderWidth: 0,
            style: {
                fontFamily: 'verdana',
                color: 'rgba(102,102,102,1.0)',
                fontSize: '10px'
            },
            maxHeight: '30%',
            position: 'bottom',
            enabled: true
        },
        plotBorderColor: 'rgba(255,255,255,0)',
        tools: {
            hidden: false,
            toImage: {
                enabled: false
            },
            sort: {
                enabled: false
            },
            enabled: false,
            fullScreen: {
                enabled: false
            }
        },
        yAxis: [
            {
                enableMinorTick: false,
                gridLineColor: '#f5f5f5',
                minorTickColor: '#d0d0d0',
                tickColor: '#d0d0d0',
                showArrow: false,
                lineColor: 'rgb(176,176,176)',
                plotLines: [],
                type: 'value',
                lineWidth: 1,
                showLabel: true,
                gridLineWidth: 1,
                enableTick: false,
                labelStyle: {
                    fontFamily: 'Verdana',
                    color: 'rgba(102,102,102,1.0)',
                    fontSize: '10px'
                },
                plotBands: [],
                position: 'left',
                labelRotation: 0,
                reversed: false,
                min: 0
            }
        ],
        style: 'gradual'
    };
};

/**
 * 多轴图表配置
 *
 * @param legend
 * @param category
 * @param series
 * @param chartOptions
 * @param labelRotate
 */
const initMultiChartOption = (
    legend: any,
    category: any,
    series: any,
    chartOptions: any,
    labelRotate = false
) => {
    const ser: any[] = [];
    forEach(legend, (_item, index) => {
        const serData: any = {};
        const data: any[] = [];
        serData['tooltip'] = {
            formatter: {
                // eslint-disable-next-line no-template-curly-in-string
                identifier: '${CATEGORY}${SERIES}${VALUE}'
            },
            shared: true,
            padding: 5,
            backgroundColor: 'rgba(0,0,0,0.5)',
            borderColor: 'rgb(0,0,0)',
            shadow: false,
            borderRadius: 2,
            borderWidth: 0,
            follow: false,
            enabled: true,
            animation: true,
            hideDelay: 3000
        };
        forEach(series[index], (v, k) => {
            const s: any = {};
            const y = v;
            s['x'] = category[k];
            s['y'] = y;
            data.push(s);
        });
        serData['data'] = data;
        serData['name'] = legend[index];
        serData['type'] = 'line';
        serData['xAxis'] = 0;
        serData['yAxis'] = index;
        ser.push(serData);
    });
    assign(chartOptions, {
        plotOptions: {
            dataLabels: {
                style: {
                    fontFamily: 'verdana',
                    color: '#1F2D3D',
                    fontSize: '10px'
                },
                connectorWidth: 1,
                align: 'outside',
                enabled: true,
                autoAdjust: true
            },
            animation: true,
            line: {
                curve: true,
                marker: {
                    symbol: ''
                },
                dataLabels: {
                    style: {
                        fontFamily: 'verdana',
                        color: '#1F2D3D',
                        fontSize: '10px'
                    },
                    connectorWidth: 1,
                    align: 'top',
                    enabled: true,
                    autoAdjust: true
                }
            }
        },
        series: ser,
        chartType: 'multiCharts',
        yAxis: [
            {
                enableMinorTick: false,
                gridLineColor: '#f5f5f5',
                minorTickColor: '#d0d0d0',
                tickColor: '#d0d0d0',
                showArrow: false,
                lineColor: '#d0d0d0',
                plotLines: [],
                type: 'value',
                lineWidth: 1,
                showLabel: true,
                gridLineWidth: 1,
                enableTick: false,
                labelStyle: {
                    fontFamily: 'Verdana',
                    color: '#6f6f6f',
                    fontSize: '10px'
                },
                plotBands: [],
                position: 'left',
                labelRotation: 0,
                reversed: false,
                min: 0
            },
            {
                enableMinorTick: false,
                gridLineColor: '#f5f5f5',
                minorTickColor: '#d0d0d0',
                tickColor: '#d0d0d0',
                showArrow: false,
                lineColor: '#d0d0d0',
                plotLines: [],
                type: 'value',
                lineWidth: 1,
                showLabel: true,
                gridLineWidth: 0,
                enableTick: false,
                labelStyle: {
                    fontFamily: 'Verdana',
                    color: '#6f6f6f',
                    fontSize: '10px'
                },
                plotBands: [],
                position: 'right',
                labelRotation: 0,
                reversed: false,
                min: 0
            }
        ]
    });
    // 标签旋转
    if (labelRotate) {
        chartOptions.xAxis.labelRotation = -25;
    }
    return chartOptions;
};

/**
 * 堆积图标配置
 *
 * @param legend
 * @param category
 * @param series
 * @param chartOptions
 */
const initAreaChartOption = (legend: any, category: any, series: any, chartOptions: any) => {
    const ser: any = [];
    forEach(legend, (_item, index) => {
        const serData: any = {};
        const data: any = [];
        serData['tooltip'] = {
            formatter: {
                // eslint-disable-next-line no-template-curly-in-string
                identifier: '${CATEGORY}${SERIES}${VALUE}'
            },
            shared: true,
            padding: 5,
            backgroundColor: 'rgba(0,0,0,0.5)',
            borderColor: 'rgb(0,0,0)',
            shadow: false,
            borderRadius: 2,
            borderWidth: 0,
            follow: false,
            enabled: true,
            animation: true,
            hideDelay: 3000
        };
        forEach(series[index], (_v, k) => {
            const s: any = {};
            s['x'] = category[k];
            s['y'] = series[index][k] || 0;
            data.push(s);
        });
        serData['data'] = data;
        serData['name'] = legend[index];
        serData['stack'] = 1;
        ser.push(serData);
    });
    assign(chartOptions, {
        plotOptions: {
            fillColorOpacity: 0.3,
            large: false,
            connectNulls: true,
            curve: true,
            marker: {
                symbol: ''
            },
            step: false,
            lineWidth: 2,
            animation: true
        },
        series: ser,
        chartType: 'area',
        legend: {
            enabled: false
        }
    });
    // 标签旋转
    chartOptions.xAxis.labelRotation = -25;
    return chartOptions;
};

export { getDefaultChartOptions, initMultiChartOption, initAreaChartOption };
